<template lang="html">
  <div style="position: relative;">
    <headerComponent/>

    <router-view v-if="$route.meta.intro"/>
    <div class="size margin" :class="{ 'size--ec': isEC }" v-else-if="$route.meta.game">
      <router-view class="animation-bottom animation-delay-01"/>
    </div>
    <div class="size margin container align-items-stretch wrap justify-content-center" v-else>
      <div class="col-12 col-xl-9 col-lg-9 col-md-8 col-sm-12 container column">
        <!-- <achievementsComponent
          v-if="!['store', 'niveis', 'perfil', 'metas', 'salaVirtual', 'personal'].includes($route.name)"
        /> -->
        <achievementsComponent
          v-show="false"
        />
        <router-view class="animation-bottom animation-delay-01"/>
      </div>
      <sidebarComponent/>
    </div>

    <footerComponent/>
    <transition name="show-menu">
      <div class="main__menu" v-if="showMenu" @click="showMenu = false">
        <font-awesome-icon class="main__menu__icon" icon="times" @click="setShowMenu(false)"/>
        <ul>
          <li @click="goTo('perfil')"><span>Perfil</span></li>
          <li><hr></li>
          <li @click="goTo('financeiro')"><span>Financeiro</span></li>
          <li><hr></li>
          <li @click="goTo('vouchers')"><span>Vouchers</span></li>
          <li><hr></li>
          <li @click="showFiles()"><span>Files</span></li>
          <li><hr></li>
          <li @click="showStudentCard()"><span>Card</span></li>
          <li><hr></li>
          <li @click="logout()"><span>Logout</span></li>
        </ul>
      </div>
    </transition>
    <modalPdf/>
    <modalStudentCard/>
  </div>
</template>

<script>
import headerComponent from '@/components/header'
import footerComponent from '@/components/footer'
import achievementsComponent from '@/components/achievements'
import sidebarComponent from '@/components/sidebar'

import modalPdf from '@/components/modal/modalPdf'
import modalStudentCard from '@/components/modal/modalStudentCard'

import appBus from '@/plugins/appBus'

export default {
  name: 'Main',
  data () {
    return {
      showMenu: false
    }
  },
  computed: {
    isEC () {
      return this.$store.getters['isEC']
    }
  },
  methods: {
    setShowMenu (show) {
      this.showMenu = show
    },
    async goTo (route) {
      this.setShowMenu(false)
      await this.$delay(200)
      this.$router.push({ name: route })
    },
    showFiles () {
      this.setShowMenu(false)
      this.$store.commit('setShowPdf', true)
    },
    showStudentCard () {
      this.setShowMenu(false)
      this.$store.commit('setShowStudentCard', true)
    },
    async logout () {
      this.setShowMenu(false)
      await this.$delay(200)
      await this.$store.dispatch('auth/logout')
    }
  },
  components: {
    headerComponent,
    footerComponent,
    achievementsComponent,
    sidebarComponent,
    modalPdf,
    modalStudentCard
  },
  mounted () {
    appBus.$on('showMenu', this.setShowMenu)
  },
  beforeDestroy () {
    appBus.$off('showMenu', this.setShowMenu)
  }
}
</script>

<style media="screen" lang="scss" scoped>
.main__menu {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(19, 0, 0, 0.95);
  width: 100vw;
  height: 100%;
  z-index: 150;
  display: flex;
  &__icon {
    position: absolute;
    top: 5vh;
    right: 5vw;
    height: 60px;
    width: 60px;
    color: #fc7f7f;
    transition: transform .2s;
    cursor: pointer;
    &:hover {
      transform: scale(1.2) rotate(90deg);
    }
  }
  ul {
    list-style-type: none;
    margin: 0 auto;
    margin-top: 25vh;
    text-align: center;
    li {
      transition: transform .2s;
      font-size: 35px;
      font-weight: 300;
      letter-spacing: 1px;
      color: #f1f1f1;
      cursor: pointer;
      &:hover {
        transform: scale(1.2);
      }
      hr {
        margin: 20px 0;
        min-width: 100%;
        color: #ffa216;
        height: 3px;
        background-color: #ffa216;
        border: none;
      }
    }
  }
}

.show-menu {
  &-enter-active {
    animation: opaque .2s ease backwards;
    animation-delay: .2s;
  }
  &-leave-active {
    animation: opaque .2s ease reverse backwards;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/index.vue